import React from 'react';
import {Page, Text, View, Image} from '@react-pdf/renderer';
import {imagePath} from "../../utils/imageUtils";
import {convertYMDtoDMY} from "../../utils/dateTimeUtils";
import {BarCode, Box, Column, Columns, LabeledText, Title} from "./pdf_common";
import { getTranslation } from '../../utils/translationUtils';
import { getBoardingPassImage } from '../../utils/themeUtils';


function AMBEventBoardingPassPage(props) {
    return (
        <Page size="A4" style={{
            flexDirection: 'column',
            backgroundColor: 'white',
            fontFamily: "pdfFont",
        }}>
            <Image src={imagePath(getBoardingPassImage(true))} style={{width: "100%", height: "auto"}}/>
            <View style={{
                padding: "24px 36px 36px 36px",
                fontSize: "10.5px",
                flex: 1,
                display: "flex",
            }}>
                <BarCode number={props.passenger.boardingPassCode} />

                <Box>
                    <Columns>
                        <Column>
                            <LabeledText label="Booking Reference" value={props.bookingData.bookingReference} />
                            <LabeledText label="Event Code" value={props.bookingData.itineraryCode} />
                            <LabeledText label="Event Date" value={convertYMDtoDMY(props.bookingData.embarkationDate)} />
                        </Column>
                        <Column>
                            <LabeledText label="Event Title" value={props.bookingData.itineraryName} />
                            <LabeledText label="Guest Name" value={`${props.passenger.title} ${props.passenger.firstName} ${props.passenger.lastName}`} />
                            <LabeledText label="Event Port" value={getTranslation(props.bookingData.arrivalPort)} />
                        </Column>
                    </Columns>
                </Box>

                <Box>
                    <Columns>
                        <Column>
                            <LabeledText label="Ship Name" value={props.bookingData.shipName} />
                            <LabeledText label="Deck Number" value={props.passenger.deckNumber || "N/A"} />
                        </Column>
                        <Column>
                            <LabeledText label="Cabin Number" value={props.passenger.cabinNumber || "N/A"} />
                            <LabeledText label="Cabin Category" value={props.passenger.cabinCategory || "N/A"} />
                        </Column>
                    </Columns>
                </Box>

                <Box>
                    <Columns>
                        <Column>
                            <LabeledText label="Embarkation Group" value={props.passenger.embarkationGroup} />
                        </Column>
                        <Column>
                            <LabeledText label="Embarkation Time" value={props.passenger.embarkationTime} />
                        </Column>
                    </Columns>
                </Box>

                <Box>
                    <Columns>
                        <Column>
                            <LabeledText label="Confirmed Restaurant" value={props.passenger.restaurantName} />
                            <LabeledText label="Confirmed Sitting" value={props.passenger.confirmedSitting} />
                        </Column>
                        <Column>
                            <LabeledText label="Confirmed Table Number" value={props.passenger.tableNumber} />
                            <LabeledText label="Confirmed Dining Time" value={props.passenger.confirmedSittingTime} />
                        </Column>
                    </Columns>
                </Box>

                <Box>
                    <Title>
                        Additional Information
                    </Title>
                    {props.bookingData?.notes?.PickupInstruction &&
                    props.bookingData?.notes?.PickupInstruction.split("\n").map((note, index) => (
                        <Text key={index} style={{marginTop: "2px"}}>
                            {note.trim()}
                        </Text>
                        ))
                    }
                </Box>

                <View style={{flex: 1}}>

                </View>
                <View style={{display:"flex", alignItems:"center", marginTop: "20px"}}>
                    <Image src={imagePath('boarding_pass_footer.jpg')} style={{width: "65%", height: "auto"}} />
                </View>
            </View>
        </Page>
    );
}

export default AMBEventBoardingPassPage;
